import React from "react";
import Page from "../components/Page";
import Grid from "@mui/material/Grid";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { AttachFile } from "@mui/icons-material";
import Button from "../elements/Button";
import { useNavigate } from "react-router-dom";

const Landing = () => {
  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/home");
  };

  const goToRules = () => {
    navigate("/rules");
  };

  return (
    <Page>
      <Grid item xs={12}>
        <div className="bg-primary flex flex-col relative">
          <div className="relative overflow-none bg-gradient-to-r from-primary to-white">
            <img
              src="/hero.jpg"
              alt="Футбольна гра"
              className="w-full h-[340px] md:h-[440px] object-cover"
            />
            <div className="absolute left-0 top-0 h-full w-full flex flex-col items-center justify-center">
              <div className="flex py-8 md:py-12 flex-col items-center justify-between h-full">
                <h2 className="uppercase text-2xl text-white border-white border bg-primary px-4 py-2 rounded-xl">
                  Прогнози на УПЛ
                </h2>
                <div className="bg-gold p-2 uppercase text-primary rounded-md font-bold">
                  Весна 2026
                </div>
                <Button onClick={goToHome}>
                  <ExitToAppIcon />
                  &nbsp;Перейти до гри
                </Button>
              </div>
            </div>
          </div>
          <div className="bg-white p-4">
            <p className="text-black mb-4">
              <strong>ФУТБАТЛ</strong> - це турнір футбольних прогнозів{" "}
              <u>без букмекерів і грошових ставок</u>, який робить перегляд
              футболу ще більш цікавим.
            </p>
            <h3 className="text-primary m-0 uppercase font-bold mb-4 border-b-2 border-primary">
              Як грати?
            </h3>
            <p className="text-black mb-4">
              ✅ Прогнозуйте рахунки футбольних матчів УПЛ
            </p>

            <p className="text-black mb-4">
              ✅ Перемагайте своїх суперників кожного туру
            </p>

            <p className="text-black mb-4">✅ Набирайте очки</p>
            <div className="flex items-center justify-center">
              <Button
                classes="!bg-gold !border-gold !text-black"
                onClick={goToRules}
              >
                <AttachFile />
                &nbsp;ПРАВИЛА ГРИ
              </Button>
            </div>
          </div>
        </div>
      </Grid>
    </Page>
  );
};

export default Landing;
